import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      {/* <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} /> */}

    </BrowserRouter>
  </React.StrictMode>
);
